module.exports = __webpack_public_path__ + "img/tank1.d9ae92b7.svg";